import { createSlice } from "@reduxjs/toolkit";

const Sync = createSlice({
  name: "Sync",
  initialState: "",
  reducers: {
    syncReducer(state, action) {
      state = action.payload;
      return state;
    },
  },
});

export const { syncReducer } = Sync.actions;
export default Sync.reducer;


